import {
  KBK_TYPE_ADM_FINES,
  KBK_TYPE_ENP,
  KBK_TYPE_INCOME_DEPOSIT_TAX,
  KBK_TYPE_INCOME_OTHER_TAX,
  KBK_TYPE_INCOME_PROGRESSIVE_TAX,
  KBK_TYPE_INCOME_TAX,
  KBK_TYPE_LAND_TAX,
  KBK_TYPE_NDFL3_INCOME_TAX,
  KBK_TYPE_PROPERTY_TAX,
  KBK_TYPE_TRANSPORT_TAX,
} from 'constants/kbkTypes';

const taxesTitleMap = {
  [KBK_TYPE_ENP]: 'единый налоговый платеж',
  [KBK_TYPE_LAND_TAX]: 'земельный налог',
  [KBK_TYPE_TRANSPORT_TAX]: 'транспортный налог',
  [KBK_TYPE_PROPERTY_TAX]: 'налог на имущество',
  [KBK_TYPE_INCOME_TAX]: 'налог на доходы',
  [KBK_TYPE_INCOME_DEPOSIT_TAX]: 'на доходы в виде процентов по вкладам',
  [KBK_TYPE_INCOME_PROGRESSIVE_TAX]: 'на доходы свыше 5 млн руб',
  [KBK_TYPE_INCOME_OTHER_TAX]: 'на иные виды доходов',
  [KBK_TYPE_ADM_FINES]: 'административный штраф',
  [KBK_TYPE_NDFL3_INCOME_TAX]: 'налог на 3НДФЛ',
};

if (process.env.NODE_ENV === 'development') {
  Object.freeze(taxesTitleMap);
}

export default taxesTitleMap;
